import { defineComponent as _defineComponent } from 'vue'
import QueryParamsService, { QueryParams } from '../../../core/query-params.service';
import ProjectListItem from './ProjectListItem.vue';
import { router } from '@/router';
import { store } from '@/store';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectList',
  setup(__props) {

const projects = computed<ProjectSnapshotViewObject[]>(() => store.getters['project/projects']);
const projectCategories = computed<Vertica.LouisPoulsen.Application.Projects.ViewModels.ProjectCategoryViewObject[]>(() => store.getters['project/projectCategories']);

const totalPages = computed<number>(() => store.getters['project/totalPages']);
const hasSearched = computed<boolean>(() => store.getters['project/hasSearched']);
const isSearching = computed<boolean>(() => store.getters['project/isSearching']);

function search(request: ProjectSearchWebRequest) : Promise<any> {
    return store.dispatch('project/search', request);
}

const accumulatedProjects = ref<ProjectSnapshotViewObject[]>([]);
const selectedProjectCategory = ref<Vertica.LouisPoulsen.Application.Projects.ViewModels.ProjectCategoryViewObject | null>(null);

const request = ref<ProjectSearchWebRequest>({
    startPage: 1,
    pages: 1,
    projectCategory: ''
});

initialize();

const showLoadMore = computed<boolean>(() => {
    return hasSearched.value && request.value.startPage < totalPages.value;
});

async function initialize() {
    initializeRequestFromQuery();
    await searchAndAddResults();

    initializeSelectedValuesAfterFirstSearch();
}

function initializeRequestFromQuery() {
    request.value.pages = parseInt(QueryParamsService.getParam(QueryParams.ProjectSearchPage), 10) || 1;
    request.value.projectCategory = QueryParamsService.getParam(QueryParams.ProjectSearchProjectCategory) || '';
}

function initializeSelectedValuesAfterFirstSearch() {
    selectedProjectCategory.value = projectCategories.value.find(c => c.name === request.value.projectCategory) || projectCategories.value[0];
    request.value.startPage = request.value.pages;
    request.value.pages = 1;
    const page = Math.min(request.value.startPage, totalPages.value).toString();
    if (QueryParamsService.getParam(QueryParams.ProjectSearchPage) !== page) {
        const query = QueryParamsService.appendQueryParams([
            { name: QueryParams.ProjectSearchPage, value: page }
        ]);
        router.replace({ query });
    }
}

async function onProjectCategoryChange() {
    request.value.projectCategory = selectedProjectCategory.value.name;
    await searchByFilterChange();
}

async function searchByFilterChange() {
    request.value.startPage = 1;
    accumulatedProjects.value = [];
    await searchAndAddResults();
}

async function loadNextPage() {
    request.value.startPage += 1;
    await searchAndAddResults();
}

async function searchAndAddResults() : Promise<void> {
    await search(request.value);
    accumulatedProjects.value = accumulatedProjects.value.concat(projects.value);
}


return { __sfc: true,projects, projectCategories, totalPages, hasSearched, isSearching, search, accumulatedProjects, selectedProjectCategory, request, showLoadMore, initialize, initializeRequestFromQuery, initializeSelectedValuesAfterFirstSearch, onProjectCategoryChange, searchByFilterChange, loadNextPage, searchAndAddResults, ProjectListItem }
}

})